import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { ROUTES } from '../app.routes';
import { RouterModule, PreloadAllModules } from '@angular/router';

import { TooltipModule } from 'primeng/tooltip';
import { PanelModule } from 'primeng/panel';
import { InputTextModule } from 'primeng/inputtext';
import { RatingModule } from 'primeng/rating';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ChartModule } from 'primeng/chart';
import { TabViewModule } from 'primeng/tabview';
import { DataViewModule } from 'primeng/dataview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RequestsModule } from '@pages/requests/requests.module';
import { ResultsModule } from '@pages/results/results.module';
import { CustRightsModule } from '@pages/page-custom-right/custrights.module';
import { ReqBskModule } from '@pages/page-reqbsk/reqbsk.module';
import { ResBskModule } from '@pages/page-resbsk/resbsk.module';
import { UserBskModule } from '@pages/page-userbsk/userbsk.module';
import { TagBskModule } from '@pages/page-tagbsk/tagbsk.module';
import { ScreenBskModule } from '@pages/page-screenbsk/screenbsk.module';
import { TagBaseModule } from '@pages/page-tag-base/tagbase.module';
import { ConfirmationService } from 'primeng/api';
import { RequestsService } from '@pages/_data/requests/requests.service';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { EditorsModule } from '@pages/page-editors/editors.module';
import { EditorRightsModule } from '@pages/page-editor-right/editorrights.module';
import { DelegateModule } from '@pages/page-delegate/delegate.module';
import { DragDropModule } from 'primeng/dragdrop';
import { DelegateRightsModule } from '@pages/page-delegate-right/delegaterights.module';
import { TranslateModule } from '@ngx-translate/core';
import { UserModule } from '@pages/page-cfg-users/user.module';
import { GroupModule } from '@pages/page-cfg-groups/group.module';
import { BasketModule } from '@pages/page-cfg-baskets/basket.module';
import { CustMenuBaseModule } from '@pages/page-custmenu-base/custmenubase.module';
import { SupervBaseModule } from '@pages/page-superv-base/supervbase.module';
import { AdminDelegateModule } from '@pages/page-admin-delegate/admindelegate.module';

@NgModule({
    imports: [
        // import Angular's modules
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(ROUTES, { useHash: true, preloadingStrategy: PreloadAllModules }),
        TooltipModule,
        PanelModule,
        InputTextModule,
        RatingModule,
        FormsModule,
        CalendarModule,
        DropdownModule,
        RadioButtonModule,
        CheckboxModule,
        InputTextareaModule,
        DialogModule,
        BreadcrumbModule,
        ChartModule,
        TabViewModule,
        DataViewModule,
        RequestsModule,
        ResultsModule,
        ReqBskModule,
        ResBskModule,
        UserBskModule,
        TagBskModule,
        ScreenBskModule,
        TagBaseModule,
        CustRightsModule,
        EditorRightsModule,        
        TriStateCheckboxModule,
        EditorsModule,
        AutoCompleteModule,
        DragDropModule,
        DelegateModule,
        DelegateRightsModule,
        TranslateModule,
        UserModule,
        GroupModule,
        BasketModule,
        CustMenuBaseModule,
        SupervBaseModule,
        AdminDelegateModule,
    ],
    providers: [
        RequestsService,
        ConfirmationService,
    ],
    exports: [CommonModule, BreadcrumbModule, TabViewModule, DataViewModule],
    declarations: [],
})
export class DocumalisModule {}
